import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  request,
  type V3ApiSuccessData,
  type V3ApiError,
} from 'services/v3ApiClient';
import { type ReviewProfileObject } from 'data/v3/data-contracts';

import { REVIEW_PROFILES_QUERY_KEY } from '../constants';
import { type CreateReviewProfileParams } from '../types';

type EditReviewProfileResponse = V3ApiSuccessData<ReviewProfileObject>;

export const useEditReviewProfile = ({
  reviewProfileId,
  onSuccess = () => {},
  onError = () => {},
}: {
  reviewProfileId: number;
  onSuccess?: (response: EditReviewProfileResponse) => void;
  onError?: (error: unknown) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation<
    EditReviewProfileResponse,
    V3ApiError,
    CreateReviewProfileParams
  >({
    mutationFn: async (params) => {
      const response = await request({
        url: `companies/review_profiles/${reviewProfileId}`,
        method: 'patch',
        data: {
          review_profile: {
            ...params,
          },
        },
      });
      return response.data;
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [REVIEW_PROFILES_QUERY_KEY],
      });
      onSuccess?.(response);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
